import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ComplianceReports from './pages/compliance-reports';
import ContentAnalysisDashboard from './pages/content-analysis-dashboard';
import RegulatoryRulesLibrary from './pages/regulatory-rules-library';
import ContentReviewDetail from './pages/content-review-detail';
import TeamManagement from './pages/team-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ComplianceReports />} />
        <Route path="/compliance-reports" element={<ComplianceReports />} />
        <Route path="/content-analysis-dashboard" element={<ContentAnalysisDashboard />} />
        <Route path="/regulatory-rules-library" element={<RegulatoryRulesLibrary />} />
        <Route path="/content-review-detail" element={<ContentReviewDetail />} />
        <Route path="/team-management" element={<TeamManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
